import {
  Box,
  chakra,
  Checkbox,
  Flex,
  Image,
  shouldForwardProp,
} from "@chakra-ui/react";
import { isValidMotionProp, motion } from "framer-motion";
import { COMMON_WEB_PATH } from "../../../../constant";
import useWebsiteInfo from "../../../../hook/useWebsiteInfo";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTransferInGameHandler } from "./transferInGameHandler";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

/**
 * @description 遊戲中轉點Modal
 * @param {function} onClose - 關閉Modal的函數
 * @returns
 */
const TransferInGameModal = ({ onClose } = {}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const { images } = useWebsiteInfo();
  const { handleTransferAllIn } = useTransferInGameHandler();

  const [isChecked, setIsChecked] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleChecked = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleConfirm = async () => {
    if (!isChecked) return;

    setButtonLoading(true);

    await handleTransferAllIn({
      handleCancel,
      setButtonLoading,
    });
  };

  const handleCancel = async () => {
    onClose();
  };

  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="rgba(0, 0, 0, 0.8)"
      zIndex="99999"
      backdropFilter="blur(2px)"
      justifyContent="center"
      alignItems="center"
    >
      <ChakraBox
        as={Flex}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.3 }}
        w="85%"
        maxWidth={"520px"}
        h="420px"
        maxHeight={"480px"}
        position={"relative"}
        bgImage={`url('${COMMON_WEB_PATH}/911TW/hintBG2.webp')`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100% 100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        p={6}
        pt="30px"
      >
        <Flex
          fontSize="24px"
          color="white"
          textAlign="center"
          bgImage={`url('${COMMON_WEB_PATH}/FlyDragon/hintTitleBG.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          sx={{ width: "-webkit-fill-available" }}
          justifyContent="center"
          alignItems="center"
          position="relative"
          minH="100px"
        >
          <Image
            src={`${COMMON_WEB_PATH}/FlyDragon/hintWORD.webp`}
            height={{
              base: "50px",
              xl: "60px",
            }}
          />
        </Flex>
        <Box pt="10px">
          <Box
            position="relative"
            h="120px"
            fontSize="20px"
            fontWeight="black"
            color="white"
            textAlign="center"
            display={"flex"}
            flexDir={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            overflow="scroll"
          >
            {i18n(
              "1.轉點期間請勿投注。若失敗將自動重試，無法成功時會將點數退回您的錢包"
            )}
            <br />
            {i18n("2.遊戲裡面的餘額若為0，入鈔成功後必須重新進入遊戲")}
          </Box>
        </Box>

        <Flex
          gap={4}
          mt={3}
          mb={3}
          h="100px"
          justifyContent="center"
          alignItems="center"
        >
          <Flex
            as="button"
            w="180px"
            h="75px"
            bgImage={`url('${images.yesBTN}')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            justifyContent="center"
            alignItems="center"
            onClick={handleConfirm}
            opacity={isChecked && !buttonLoading ? 1 : 0.5}
            filter={isChecked && !buttonLoading ? "none" : "grayscale(1)"}
            cursor={isChecked && !buttonLoading ? "pointer" : "not-allowed"}
          ></Flex>

          <Flex
            as="button"
            w="180px"
            h="75px"
            bgImage={`url('${images.cancelBTN}')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            cursor="pointer"
            justifyContent="center"
            alignItems="center"
            onClick={handleCancel}
            _hover={{ filter: "brightness(1.1)" }}
          ></Flex>
        </Flex>
        <Checkbox
          isChecked={isChecked}
          name="remember_account"
          onChange={handleChecked}
          color={"#e495ff"}
          mb="10px"
        >
          {i18n("我瞭解了")}
        </Checkbox>
      </ChakraBox>
    </Flex>
  );
};

export default TransferInGameModal;
